export const projectIdKey = "projectId";
export const attachmentIdKey = "attachmentId";
export const kpiIdKey = "kpiId";
export const okrIdKey = "okrId";

export enum PROJECT_TAB_KEYS {
  Overview = "overview",
  Team = "team",
  Attachements = "attachments",
  Kpis = "kpis",
  Okrs = "okrs",
}
